import React from "react";
import Layout from "../layouts/index";
import ForgotPassword from "../screens/Accounts/ForgotPassword";

const ForgotPasswordPage = () => {
  return (
    <Layout>
      <ForgotPassword />
    </Layout>
  );
};

export default ForgotPasswordPage;
